import React from 'react'
import './support.scss';

/* Support page that addresses the needs of both intended audiences */
const Support = () => {
  return (
    <section id="support">
      <div className="tile" >
        <br/>
        <br/>
        Volunteer FAQ: <br/>
        1. How can I become a volunteer? <br/>
        To become a volunteer, simply navigate to the volunteer page and search away!
        <br/>
        <br/>
        2. What types of volunteer opportunities are available? <br/>
        We offer a variety of opportunities ranging from event assistance to remote projects – you can choose based on your interests and skills.
        <br/>
        <br/>
        3. What time commitment is expected?<br/>
        Time commitments vary by role, but we appreciate any amount of time you can contribute, whether it's a few hours for an event or more regular involvement in a specific project.
        <br/>
        <br/>
        <br/>
        <br/>
        Contact: <br/>
        For any support inquiries, please <br/>
        contact us at volunteer@econet.com.
      </div>

      <div className="divider"></div>

      <div className="tile" >
      <br/>
        <br/>
        Organization FAQ: <br/>
        1. How can I add my organization? <br/>
        Fill out our online application form on our website. Please wait 3-5 business days for us to verify and approve your request.
        <br/>
        <br/>
        2. What kinds of organizations are eligible to participate? <br/>
        We welcome a diverse range of organizations, including non-profits, community groups, schools, and more, that have legitimate volunteer opportunities to offer.
        <br/>
        <br/>
        3. What level of commitment is required from our organization? <br/>
        Simply fill out the form on our organization page and we will take care of the rest!
        <br/>
        <br/>
        <br/>
        <br/>
        Contact: <br/>
        For any support inquiries, please <br/>
        contact us at organization@econet.com.
      </div>
    </section>
  )
}

export default Support
